export const VerificationAgencyClient = `VerificationAgencyClient/`;
export const CompanyDetails = VerificationAgencyClient + `CompanyDetails/`;
export const VAClientSearch = VerificationAgencyClient + `Search`;
export const ReferredBy = VerificationAgencyClient + `ReferredBy/`;
export const ReferredByExternalPage = VerificationAgencyClient + `ReferredByExternalPage`;
export const GetAll = VerificationAgencyClient + 'GetAll';
export const GetClientNames = VerificationAgencyClient + 'GetClientNames';
export const UpdateCompanyDetailsByAccessToken = VerificationAgencyClient + 'CompanyDetailsByAccessToken';
export const GetCompanyDetailsForExternalApplication = VerificationAgencyClient + 'CompanyDetailsByTemporaryToken/Application/';
export const GetCompanyDetailsForExternalFeedback = VerificationAgencyClient + 'CompanyDetailsByTemporaryToken/Feedback/';
export const BEEGeneratedCertificates = "BEEGeneratedCertificates/";
export const SearchGeneratedCertificates = BEEGeneratedCertificates + 'Search/';
export const DownloadCertificate = BEEGeneratedCertificates + 'DownloadCertificate/';
export const FeedbackDetails = VerificationAgencyClient + 'FeedbackDetails/';
export const FeedbackSearch = FeedbackDetails + 'Search';
export const FeedbackSendEmail = FeedbackDetails + 'SendLink';
export const IsTokenActive = FeedbackDetails + 'IsTokenActive/';